import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function getDepartments() {
  const res = await api.get(
    generatePath('organization/department/'),
    config('json')
  );

  return res.data;
}
